<template>
  <div style="background: #f6f6f6;min-height: 100%;">
    <!-- bar -->
    <van-nav-bar
        title="分货直购"
        left-arrow
        class="my-nav"
        :fixed="true"
        @click-left="$router.back(-1)"
    >
      <!--<template #right>
        <van-icon name="search" size="18" />
      </template>-->
    </van-nav-bar>

    <!-- 可上划刷新、下滑加载的列表 -->
    <!-- <van-pull-refresh
      style="margin-bottom: 50px"
      v-model="refreshing"
      @refresh="onRefresh"
    > -->
    <van-list
        style="padding-top: 50px;"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
    >

      <van-tabs @click="onClickChangeType">
        <van-tab title="整单提">
          <div style="margin-top: 5px"></div>
          <!-- 查询参数 -->
          <van-field
              readonly
              clickable
              name="picker"
              :value="params.shopName"
              label="商家"
              placeholder="点击选择商家"
              @click="showPicker = true"
              left-icon="shop-o"
              right-icon="arrow-down"
          />
          <van-field
              v-if="params.isWholeOrder === true"
              readonly
              clickable
              name="picker"
              :value="showBatch"
              label="分货批次"
              placeholder="点击选择分货批次"
              @click="showBatchPicker = true"
              left-icon="filter-o"
              right-icon="arrow-down"
          />

        </van-tab>
        <van-tab title="普通分货">
          <div style="margin-top: 5px"></div>
          <van-field
              readonly
              clickable
              name="picker"
              :value="params.shopName"
              label="商家"
              placeholder="点击选择商家"
              @click="showPicker = true"
              left-icon="shop-o"
              right-icon="arrow-down"
          />
          <van-field
              v-if="params.isWholeOrder === false"
              v-model="params.goodsName"
              label="产品名称"
              placeholder="请输入产品名称"
              left-icon="bag-o"
              @blur="search"
          />

        </van-tab>
        <van-tab title="组合分货">
          <div style="margin-top: 5px"></div>
          <!-- 查询参数 -->
          <van-field
              readonly
              clickable
              name="picker"
              :value="params.shopName"
              label="商家"
              placeholder="点击选择商家"
              @click="showPicker = true"
              left-icon="shop-o"
              right-icon="arrow-down"
          />
          <van-field
              readonly
              clickable
              name="picker"
              :value="showCpBatch"
              label="分货批次"
              placeholder="点击选择分货批次"
              @click="showCpBatchPicker = true"
              left-icon="filter-o"
              right-icon="arrow-down"
          />
        </van-tab>
      </van-tabs>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="onCancel"
            :default-index="0"
        />
      </van-popup>
      <!-- 分货批次弹出选择 -->
      <van-popup v-model="showBatchPicker" position="bottom">
        <van-picker
            show-toolbar
            :columns="batchColumns"
            @confirm="onConfirmBatch"
            @cancel="onCancelBatch"
            :default-index="0"
            cancel-button-text="清除已选"
        />
      </van-popup>

      <!-- 省办分货批次弹出选择 -->
      <van-popup v-model="showCpBatchPicker" position="bottom">
        <van-picker
            show-toolbar
            :columns="cpBatchColumns"
            @confirm="onConfirmCpBatch"
            @cancel="()=>{}"
            :default-index="0"
            cancel-button-text="清除已选"
        />
      </van-popup>
      <template v-if="showCp">
        <CompositePackage v-if="cpData.aGoods&&cpData.aGoods.length" ref="cp" :data="cpData"></CompositePackage>
        <van-empty v-else description="暂无分货"></van-empty>
      </template>
      <template v-else>
        <!-- 全选按钮 -->
        <div class="check-all-warp">
          <div style="display: flex" @click="onClickAll(!checkAll)">
            <van-checkbox
                :value="checkAll"
            ></van-checkbox>
            &nbsp;
            全选
          </div>
        </div>
        <!-- 分货信息 -->
        <template v-if="data.length>0">
          <div class="card"
               v-for="(item, index) in data"
               :key="index">
            <div class="card-header">
              商家： {{ item.shopName }}
              <van-checkbox v-model="item.checked" :disabled="params.isWholeOrder"></van-checkbox>
            </div>
            <div class="card-body">
              <div class="line">
                <label class="label">产品名称:</label>
                {{ item.goodsName }}
              </div>
              <div class="line">
                <label class="label">SKU编码:</label>
                {{ item.skuCode }}
              </div>
              <div class="line">
                <label class="label">规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格:</label>
                {{ item.specifications }}
              </div>
              <div class="line">
                <label class="label">分货批次:</label>
                {{ item.stockReceiptName }}
              </div>
              <div class="line">
                <label class="label">商品单价:</label>
                <small style="color: #f11826">￥{{ item.amount }}</small>
              </div>
            </div>
            <div class="card-footer">
              <div>
                <label class="label">分货数量:</label> {{ item.distributionStockQty }}
              </div>
              <div>
                <label class="label">可购数量:</label> {{ item.stock }}
                <van-tag type="primary" v-if="item.allBuy && !params.isWholeOrder">全</van-tag>
              </div>
              <div><label class="label">购买数量:</label>
                <input type="number" class="number-input" v-model="item.buyNum"
                       :readonly="item.allBuy || params.isWholeOrder">
              </div>
            </div>
          </div>
        </template>
        <van-empty v-else description="暂无分货"></van-empty>
      </template>

    </van-list>
    <!-- </van-pull-refresh> -->

    <div
        style="
        position: fixed;
        bottom: 0px;
        width: 100%;
        background: white;
        border-radius: 10px;
      "
    >
      <div class="van-sku-actions">
        <button
            class="van-button van-button--warning van-button--large"
            :disabled="showCp"
            @click="addCart"
        >
          <div class="van-button__content">
            <span class="van-button__text">加入购物车</span>
          </div>
        </button
        >
        <button
            class="van-button van-button--danger van-button--large"
            @click="purchase"
        >
          <div class="van-button__content">
            <span class="van-button__text">立即购买</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../api/http";
import {API} from "../../api/const";
import {saveAll} from "../../api/carts";
import {Toast} from "vant";
import bus from "../../bus";
import CompositePackage from "@/views/direct-purchase/CompositePackage";
import {listOptions, getInfo} from "@/api/direct-purchase";

export default {
  data() {
    return {
      // columns: ["山东德恩怡华通信科技有限公司","山东新松联通讯","山东宏米通讯","龙龙手机店","技术商家测试账号"],
      // columns: ["山东德恩怡华通信科技有限公司", "山东新松联电子科技有限公司", "山东戴革通信数码有限公司", "山东艾吉姆电子商务有限公司", "山东金怡华公司（新业务）"],
      columns: ["山东德恩怡华通信科技有限公司", "山东金怡华公司（新业务）","山东捷盛途电子科技有限公司", "赛米联合促销店", "赛米荣耀联合促销店", "山东润盈通信设备有限公司"],
      shops: [
        {
          shopName: "山东德恩怡华通信科技有限公司",
          shopId: 11,
        },
        // {
        //   shopName: "山东新松联电子科技有限公司",
        //   shopId: 12,
        // },
        // {
        //   shopName: "山东戴革通信数码有限公司",
        //   shopId: 16,
        // },
        // {
        //   shopName: '山东艾吉姆电子商务有限公司',
        //   shopId: 17
        // },
        {
          shopName: "山东金怡华公司（新业务）",
          shopId: 18,
        },
        {
          shopName: "山东捷盛途电子科技有限公司",
          shopId: 20,
        },
        {
          shopName: "赛米联合促销店",
          shopId: 23,
        },
        {
          shopName: "赛米荣耀联合促销店",
          shopId: 24,
        },
        {
          shopName: "山东润盈通信设备有限公司",
          shopId: 25,
        },
        // {
        //   shopName: "龙龙手机店",
        //   shopId: 14,
        // },
        // {
        //   shopName: "技术商家测试账号",
        //   shopId: 10,
        // },
      ],
      typeColumns: ["整单提", "普通分货"],
      batchColumns: [
        // '11.14测试整单提'
      ],
      showCpBatch: undefined,
      cpBatchColumns: [],
      cpBatchs: [],
      batchs: [
        // {
        //   id:444,
        //   name: '11.14测试整单提'
        // }
      ],
      showTypePicker: false,
      showBatchPicker: false,
      showCpBatchPicker: false,
      showPicker: false,
      loading: false,
      finished: false,
      refreshing: false,
      params: {
        page: 0,
        size: 200,
        shopId: 11,
        shopName: '山东德恩怡华通信科技有限公司',
        goodsName: undefined,
        isWholeOrder: true
      },
      data: [],
      totalPages: 0,
      showType: '整单提',
      showBatch: undefined,
      showCp: false,
      cpData: {},
    };
  },
  mounted() {
    this.loadData();
    this.loadDistributionBatch();
  },
  components: {
    CompositePackage
  },
  computed: {
    checkAll() {
      return this.data.length == 0 ? false : this.data.filter(o => o.checked).length == this.data.length
    }
  },
  methods: {
    onClickChangeType(index, value) {
      this.showCp = false
      if (value === '整单提') {
        this.params.isWholeOrder = true;
      } else if (value == '组合分货') {
        this.showCp = true
      } else {
        this.params.isWholeOrder = false;
        this.clearDistributionBatch();
      }
      this.search();
    },
    async onConfirmCpBatch(value) {
      this.showCpBatch = value;
      this.showCpBatchPicker = false;
      let batchIndex = this.cpBatchs.findIndex((a, b, c) => {
        return a.name === value;
      });
      let d = await getInfo(this.cpBatchs[batchIndex].id)
      d = d.data
      d.aGoods.forEach(o => o.buyNum = 0)
      d.bGoods.forEach(o => o.buyNum = 0)
      this.cpData = d;
    },
    onConfirmBatch(value) {
      this.showBatch = value;
      this.showBatchPicker = false;
      let batchIndex = this.batchs.findIndex((a, b, c) => {
        return a.name === value;
      });
      this.params.stockReceiptId = this.batchs[batchIndex].id;
      this.search();
    },
    onConfirmType(value) {
      this.showTypePicker = false;
      this.showType = value;
      if (value === '整单提') {
        this.params.isWholeOrder = true;
      } else {
        this.params.isWholeOrder = false;
        this.clearDistributionBatch();
      }
      this.search();
    },
    clearDistributionBatch() {
      this.params.stockReceiptId = undefined;
      this.showBatch = undefined;
    },
    onConfirm(value) {
      this.params.shopName = value;
      let shopIndex = this.shops.findIndex((a, b, c) => {
        return a.shopName === value;
      });
      this.params.shopId = this.shops[shopIndex].shopId;
      this.showPicker = false;
      this.search()
      this.clearDistributionBatch();
      this.loadDistributionBatch();
    },
    onCancel() {
      this.showPicker = false;
      this.showTypePicker = false;
      // this.params.shopId = undefined;
      // this.params.shopName = undefined;
    },
    onCancelBatch() {
      this.showBatchPicker = false;
      this.clearDistributionBatch();
      this.search();
    },
    structureShop(items) {
      items.forEach((item) => {
        this.shops.push({shopId: item.shopId, shopName: item.shopName});
        this.columns.push(item.shopName);
      });
      this.shops = Array.from(new Set(this.shops));
      this.columns = Array.from(new Set(this.columns));
    },
    search() {
      this.params.page = 0;
      this.finished = false;
      this.loadData();
    },
    addCart() {
      let checkedData = this.data.filter((item) => {
        return item.checked;
      });
      let canBuyChecked = this.data.filter((item) => {
        return item.checked && item.stock > 0;
      });
      if (canBuyChecked.length > 0) {
        let carts = undefined;
        if (this.params.isWholeOrder) {
          // let batchId = this.uuid();
          carts = checkedData.map((item) => ({
            shopId: item.shopId,
            skuCode: item.skuCode,
            number: item.buyNum,
            skuId: item.skuId,
            goodsId: item.goodsId,
            stepperLimit: item.stock,
            batchId: item.stockReceiptId,
            allBuy: true
          }));
        } else {
          carts = checkedData.map((item) => ({
            shopId: item.shopId,
            skuCode: item.skuCode,
            number: item.buyNum,
            skuId: item.skuId,
            goodsId: item.goodsId,
            stepperLimit: item.stock,
            allBuy: item.allBuy
          }));
        }
        carts = carts.filter(o => o.number > 0)
        saveAll(carts, (_) => {
          Toast("加入购物车成功");
        });
      } else if (checkedData.length > 0) {
        Toast("库存不足");
      } else {
        Toast("请选择商品");
      }
    },
    uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      }).replace(/[-]/g, "");
    },
    async purchase() {
      if (this.showCp) {
        try {
          let d = await this.$refs.cp.listBuySku()

          if (d.length > 0) {
            let buy = {
              id: this.params.shopId,
              name: this.params.shopName,
              commodity: d
            }
            bus.state.buyList = [buy];
            this.$router.push("/order-submit");
          } else {
            Toast("请选择商品");
          }
        } catch (e) {
          Toast(e);
        }

      } else {
        // // 过滤出被选择的商品
        let checkedData = this.data.filter((item) => {
          return item.checked;
        });
        let canBuyChecked = this.data.filter((item) => {
          return item.checked && item.stock > 0;
        });
        if (canBuyChecked.length > 0) {
          axios
              .post(API + "/v2/goods/genericPurchase", checkedData)
              .then((res) => {
                // 完成拼装，跳转结算页
                let standardList = res.data.filter(item => {
                  return item.commodity.length > 0;
                })
                if (standardList.length > 0) {
                  bus.state.buyList = res.data;
                  this.$router.push("/order-submit");
                } else {
                  Toast("库存不足");
                }
              });
        } else if (checkedData.length > 0) {
          Toast("库存不足");
        } else {
          Toast("请选择商品");
        }
      }

    },
    onClickAll(status) {
      if (!this.params.isWholeOrder) {
        this.data.forEach((item) => {
          item.checked = status;
        });
      }
    },
    loadData() {
      this.resetData();
      let params = this.params;
      axios.get(API + "/v2/goods/my_goods", {params}).then((res) => {
        this.data = res.data.content;
        let resNum = res.data.totalElements;
        let size = this.params.size;
        this.totalPages =
            resNum % size == 0 ? resNum / size : parseInt(resNum / size) + 1;
        // 后台返回字段有问题，totalPages为当前页，page
        this.params.page = res.data.totalPages;
        // this.structureShop(res.data.content);
      });
    },
    loadDistributionBatch() {
      let params = this.params;
      axios.get(API + "/v2/goods/distribution-batch", {params}).then((res) => {
        this.batchColumns = res.data.map(item => {
          return item.name;
        });
        this.batchs = res.data;
      });
      listOptions(params).then(d => {
        this.cpBatchColumns = d.data.map(o => o.name)
        this.cpBatchs = d.data
      })
    },
    resetData() {
      this.data = [];
      this.totalPages = 0;
      this.totalElements = 0;
      if (this.params.isWholeOrder) {
        this.params.size = 200;
      } else {
        this.params.size = 10;
      }
    },
    onLoad() {
      if (this.params.page > 0) {
        let params = this.params;
        axios.get(API + "/v2/goods/my_goods", {params}).then((res) => {
          if (this.params.page < this.totalPages) {
            res.data.content.forEach((item) => {
              this.data.push(item);
            });
          }
          // 后台返回字段有问题，totalPages为当前页，page
          this.params.page = res.data.totalPages;
          let resNum = res.data.totalElements;
          let size = this.params.size;
          this.totalPages =
              resNum % size == 0 ? resNum / size : parseInt(resNum / size) + 1;
          this.loading = false;
          // this.structureShop(res.data.content);
          if (this.params.page >= this.totalPages) {
            this.finished = true;
          }
        });
      } else {
        this.loading = false;
      }
    },
    onRefresh() {
    },
  },
};
</script>

<style>
.font-size-class {
  font-size: 14px;
  margin-bottom: 10px;
  color: #afafaf;
}

.font-size-class-content {
  font-size: 14px;
  margin-bottom: 10px;
}

.interval {
  margin-bottom: 10px;
}

.input-class {
  width: 34px;
  border-radius: 11px;
  border: solid 1px #afafaf;
  text-align: -webkit-center;
}

/*中间的过度的横线*/
.link-top {
  width: 95%;
  height: 1px;
  border-top: solid #f7f7f7c9 1px;
  margin-top: 12px;
  margin-bottom: 8px;
}
</style>
<style lang="less" scoped>
.check-all-warp {
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
  align-items: center;
  color: #999;
  font-size: 13px
}

.card {
  background: #fff;
  padding: 0 10px;
  margin: 5px 5px 20px;
  border-radius: 5px;
  font-size: 14px;
  box-shadow: 5px 5px 3px #ddd;
  color: #333;

  .card-header {
    padding: 0 10px;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
  }

  .card-body {
    padding: 10px;
    font-size: 12px;
  }

  .card-footer {
    padding: 0 10px;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }

  .line {
    height: 30px;
    line-height: 30px;
  }

  .label {
    color: #999;
    margin-right: 10px;
  }

  .number-input {
    width: 60px;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    padding: 0 10px;
    box-sizing: border-box;
    border: 1px solid #999;

    &[readonly='readonly'] {
      background: #eee;
    }
  }

  .van-tag {
    margin-left: 10px;
  }
}

.van-button[disabled="disabled"] {
  background: #aaa;
  color: #eee;
}
</style>
